import { ApiDataStatus, BadgeVariant, CustomerSfId, Offer, OpportunityCategory, EquipmentCategory } from '../types'
import * as i18next from 'i18next'

export enum OpportunityStatus {
  DiscountApprovalPending = 'DiscountApprovalPending',
  DiscountApprovalRejected = 'DiscountApprovalRejected',
  OfferStatusIncomplete = 'OfferStatusIncomplete',
  OfferCreated = 'OfferCreated',
  OfferInProgress = 'OfferInProgress',
  SentToSap = 'SentToSap',
  BeginPrepare = 'BeginPrepare',
  PrepareInProgress = 'PrepareInProgress',
  GroupingInProgress = 'GroupingInProgress',
  SyncWithSalesForce = 'SyncWithSalesForce'
}

export type OpportunitiesDataType = {
  myOpportunities: CustomerModel[] | null
  sharedOpportunities: CustomerModel[] | null
  status: ApiDataStatus
}

export interface OpportunitiesProps {
  customers: CustomerModel[] | null
  dataStatus: ApiDataStatus
  onOpportunityDialogUpdate?: (isOpen: boolean) => void
}

export interface OpportunityModel {
  id: string
  customerId: CustomerSfId
  name: string
  dueDate: Date
  category: OpportunityCategory
  owner: string
  ownerId: string
  offer?: Offer | undefined
  buildingEquipments?: BuildingEquipment[]
}

export type BuildingEquipment = {
  element: string
  count: number
  elementDescription: string
  category?: EquipmentCategory
}

export interface CustomerModel {
  id: CustomerSfId
  name: string
  dueDate: Date
  numberOfContracts: number
  opportunities: OpportunityModel[]
}

export interface StatusBadgeProps {
  status: OpportunityStatus
  variant: BadgeVariant
  label: string
  icon?: string
}

export type OpportunitiesIndexSortBy = 'dueDate' | 'name' | 'undefined'

export type FilterType = 'category' | 'status' | 'undefined'

export type OpportunityFilterOption = {
  key: string
  value: (i18n: i18next.i18n) => string
  filterType: FilterType
  disabled?: boolean
}

export type OpportunitySortOption = {
  key: string
  value: string
  sortType: OpportunitiesIndexSortBy
  sortOrderDescending: boolean
  disabled?: boolean
}
